import { Icon, useStyleConfig } from '@chakra-ui/react';
import React from 'react';

import { WLIconProps } from '../icon.props.interface';

const PeopleIcon: React.FC<WLIconProps> = ({ variant, ...rest }) => {
  const styles = useStyleConfig('Icon', { variant });

  return (
    <Icon viewBox="0 0 255 255" {...rest} __css={styles}>
      <desc id="svgdescHrst">people</desc>
      <path
        className="background"
        d="M127.5 0C57.2 0 0 57.2 0 127.5S57.2 255 127.5 255 255 197.8 255 127.5 197.8 0 127.5 0z"
      />
      <path
        className="accent"
        d="M161.7 142.6c-2.9-1.6-6-3.1-8.9-4.5-1.5-.8-3.1-1.5-4.6-2.3-1-.5-2-1-2.5-1.3.2-.5.7-1.4 1.2-2.2l.1-.3c6.4-11.2 8.7-23.9 7-38.6-1.3-10.5-7.8-17.5-18.5-19.7-2.2-.4-4.5-.7-6.9-.7-1 0-2 0-3.1.1-12.4.9-20.6 8.4-22.3 20.6-.5 3.5-.6 7.5-.3 12.4.3 6.2.9 12.8 3.4 18.9 1.4 3.4 3.6 5.7 5.6 8.1.7.8 1.5 1.7 2.3 2.6l.2.2c-.1.1-.3.1-.4.2-2.3 1.1-5.1 1.9-8.1 2.8-3.5 1-7.2 2.1-10.2 3.7-12.1 6.6-19.2 16.5-21.1 29.4-.8 5.3 1.3 8.5 6.6 9.8 3.2.8 6.4 1.4 10 2 8.9 1.6 17.8 2.3 24.5 2.8H142.1c1.6-.2 3.3-.3 4.9-.5 3.7-.4 7.5-.7 11.2-1.2 4.9-.6 11.3-1.5 17.7-3 5.8-1.4 8-4.6 7.1-10.3-2.2-12.7-9.3-22.4-21.3-29z"
      />
      <path
        className="accent"
        d="M93 137.9c1.3-.7 2.7-1.3 4.1-1.9-2.2-1.1-4.4-2.1-6.5-3.2-4.1-2-4-2-1.8-5.8 5.8-10.2 7.2-21.2 5.9-32.6-1-8.6-6.3-14-14.7-15.7-2.7-.6-5.5-.6-8.2-.5-10 .7-16.4 6.6-17.8 16.4-.5 3.5-.5 7-.3 10.5.3 5.4.8 10.9 2.8 15.9 1.5 3.6 4.2 5.9 6.6 8.9 1.4 1.8.8 2.3-.9 3.1-4.7 2.2-11.4 3.2-15.9 5.7-9.7 5.3-15.9 13.2-17.5 24.3-.5 3.8.7 5.6 4.4 6.6 2.8.7 5.7 1.2 8.6 1.7 7 1.2 14.1 1.9 21.2 2.5h6c0-.9.1-1.7.2-2.7 2.1-14.5 10.2-25.7 23.8-33.2zM230.2 160.7c-1.7-11-7.9-18.8-17.5-24.1-3.8-2.1-7.8-3.9-11.8-5.9-4.1-2-4-2-1.8-5.8 5.8-10.2 7.2-21.2 5.9-32.6-1-8.6-6.3-14-14.7-15.7-2.7-.6-5.5-.6-8.2-.5-10 .7-16.4 6.6-17.8 16.4-.5 3.5-.5 7-.3 10.5.3 5.4.8 10.9 2.8 15.9 1.5 3.6 4.2 5.9 6.6 8.9 1.4 1.8.8 2.3-.9 3.1-3.8 1.8-8.9 2.8-13.1 4.4 1.6.8 3.2 1.6 4.9 2.5 13.5 7.4 21.6 18.5 23.8 32.9 0 .3.1.6.1.9h7.8c4.7-.5 9.4-.9 14.1-1.4 5.1-.6 10.2-1.4 15.2-2.6 4.2-.9 5.5-2.8 4.9-6.9z"
      />
    </Icon>
  );
};

export default PeopleIcon;
